<main class="login-shell" [class.login-shell--platform]="isPlatformPortal">
  <section class="brand-panel" aria-labelledby="login-brand-title">
    <div class="brand-panel__inner">
      <p class="brand-panel__pillars">{{ i18n.t('auth.login.brandPillars') }}</p>
      <img class="brand-panel__logo" src="images/juno-audit-logo.png" alt="Juno Audit" />

      <div class="brand-panel__copy">
        <h1 id="login-brand-title">
          {{ isPlatformPortal ? 'Juno Platform' : i18n.t('auth.login.brandTitle') }}
        </h1>
        <p class="lead">
          {{
            isPlatformPortal
              ? 'Zarządzanie klientami, tenantami i administratorami.'
              : i18n.t('auth.login.brandDescription')
          }}
        </p>
      </div>
    </div>
  </section>

  <section class="form-panel" aria-labelledby="login-form-title">
    <div class="login-card">
      <h2 id="login-form-title">
        {{ isPlatformPortal ? 'Logowanie administratora platformy' : i18n.t('auth.login.title') }}
      </h2>
      <p class="form-lead center">
        {{
          isPlatformPortal
            ? 'Dostęp wyłącznie dla kont z rolą SUPER_ADMIN.'
            : i18n.t('auth.login.subtitle')
        }}
      </p>

      <form class="app-form" [formGroup]="form" (ngSubmit)="submit()">
        @if (validationMessage; as message) {
          <div class="form-message" role="alert"><span class="app-message__icon app-message__icon--error fa-solid fa-circle-exclamation" aria-hidden="true"></span> {{ message }}</div>
        }

        <label
          class="app-field"
          [class.app-field--invalid]="
            submitAttempted() && form.controls.username.hasError('required')
          "
        >
          <span class="app-field__label">
            {{ i18n.t('auth.login.fields.username') }}
            @if (submitAttempted() && form.controls.username.hasError('required')) {
              <span class="app-required-indicator">*</span>
            }
          </span>
          <input
            type="text"
            formControlName="username"
            autocomplete="username"
            required
            [placeholder]="i18n.t('auth.login.placeholders.username')"
          />
        </label>

        <label
          class="app-field"
          [class.app-field--invalid]="
            submitAttempted() && form.controls.password.hasError('required')
          "
        >
          <span class="app-field__label">
            {{ i18n.t('auth.login.fields.password') }}
            @if (submitAttempted() && form.controls.password.hasError('required')) {
              <span class="app-required-indicator">*</span>
            }
          </span>
          <input
            type="password"
            formControlName="password"
            autocomplete="current-password"
            required
            [placeholder]="i18n.t('auth.login.placeholders.password')"
          />
        </label>

        <button
          class="primary-button primary-button--brand-dark"
          type="submit"
          [disabled]="isSubmitting()"
        >
          <span>
            {{
              isSubmitting()
                ? i18n.t('auth.login.actions.submitting')
                : i18n.t('auth.login.actions.submit')
            }}
          </span>
          @if (isSubmitting()) {
            <i class="fa-solid fa-spinner fa-spin" aria-hidden="true"></i>
          } @else {
            <i class="fa-solid fa-arrow-right" aria-hidden="true"></i>
          }
        </button>
      </form>
    </div>
  </section>
</main>
